import { useCallback } from 'react';
import { commitLocalUpdate, useRelayEnvironment } from 'react-relay';
import type { SelectorStoreUpdater } from 'relay-runtime';
import { statusCategoryForId } from '@atlassian/jira-common-constants/src/status-categories.tsx';
import type { Options, StatusUpdateHandler } from '../types.tsx';

export function useHandleStatusUpdate(
	updater: SelectorStoreUpdater,
	{ isHideDoneEnabled }: Options,
) {
	const environment = useRelayEnvironment();

	return useCallback<StatusUpdateHandler>(
		(_, fieldName, field) => {
			if (!isHideDoneEnabled) return;
			if (fieldName !== 'status') return;
			if (statusCategoryForId(field.statusCategory?.statusCategoryId) !== 'DONE') return;

			commitLocalUpdate(environment, updater);
		},
		[environment, isHideDoneEnabled, updater],
	);
}
